// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__34Wc6","item":"PaymentsMobile_item__33mqd","label":"PaymentsMobile_label__1Fe_p","amount":"PaymentsMobile_amount__1eKBe"};